import { render, staticRenderFns } from "./ModalExportContacts.vue?vue&type=template&id=1aa220b6&"
import script from "./ModalExportContacts.vue?vue&type=script&lang=js&"
export * from "./ModalExportContacts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/blocks/ModalExportContacts.vue
// module id = null
// module chunks = 